import day from 'utils/day';
import { appointments as appointmentsConstants } from 'bmiq-common';

export const onViewChange = (value, setCalendarView, setTitle, calendar, saveCalendarPreferences = () => {}, activeProviders = []) => {
  setCalendarView(value);
  saveCalendarPreferences({ calendarView: value, selectedProviders: activeProviders.map(({ id }) => id) });
  const date = day.tz(calendar.getDate());
  switch (value) {
    case 'timeGridWeek':
      setTitle(`${date.startOf('week').format('MMM D')} - ${date.endOf('week').format('D, YYYY')}`);
      break;
    case 'dayGridMonth':
      setTitle(date.format('MMMM YYYY'));
      break;
    default:
      setTitle(date.format(' MMM DD, YYYY'));
  }
};

export const formatDate = (timeStr, calendarDay) => {
  if (!timeStr || !calendarDay) return new Date();
  const timeString = [timeStr.slice(0, -2), ' ', timeStr.slice(-2)].join('');
  const date = day(calendarDay).format('MM-DD-YYYY');
  return day(`${date} ${timeString}`, 'MM-DD-YYYYTHH:mm').format();
};

export const validHours = (startTime, endTime) => day(startTime, 'hh:mma').isBefore(day(endTime, 'hh:mma'));

export const validateStartTime = (startTime, endTime) => {
  if (startTime && endTime && !validHours(startTime, endTime)) {
    return {
      help: 'Please input valid time',
      validateStatus: 'error',
    };
  }
  return {};
};

/**
 * Get Current and upcoming months List
 * @returns {Object} Months List
 */
export const currentAndUpcomingMonths = () => {
  const monthsQt = [...Array(12)];
  return monthsQt
    .map((res, i) => ({
      month: day().month(i).format('MMMM'),
      year: day().format('YYYY'),
    }))
    .filter((_res, i) => i >= day().format('M') - 1);
};

export const isToday = date => {
  const today = new Date();
  return date.getDate() === today.getDate() && date.getMonth() === today.getMonth() && date.getFullYear() === today.getFullYear();
};

export const formatAppointmentTitle = participants => {
  const { participantTypes } = appointmentsConstants;

  return participants[participantTypes.PATIENT].length > 1 ? 'Multi-Patient' : participants[participantTypes.PATIENT][0].fullName;
};

export const availableColorKeys = [1, 2, 3, 4, 5];
export const groupedColorProvider = ({ key }) => ({
  borderColor: `rgba(${colorNameList[key]})`,
  backgroundColor: `rgba(${colorNameList[key]})`,
  checkboxColor: `rgb(${colorNameList[key]})`,
  textColor: '#fff',
});

const colorNameList = [
  '65,140,171,1', // rgba(65, 140, 171, 1)
  '133,66,147,1', // rgba(133, 66, 147, 1)
  '110, 101, 200, 1', // rgba(110, 101, 200, 1)
  '66,147,110,1', // rgba(66, 147, 110, 1)
  '195,93,118,1', // rgba(195, 93, 118, 1)
];
